import type { NavigationGuardNext, RouteRecordNormalized } from "vue-router"
import {$auth} from "@/plugins/auth"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"

export default class NotSubscribed implements App.Middleware.Instance {
  async handle(
    to: RouteRecordNormalized,
    from: RouteRecordNormalized,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    // Cursor: Handle unauthenticated users by allowing Authorized middleware to handle redirect
    if (!$auth.user) {
      return next(to, from, cancel)
    }

    if (!$auth.user!.account!.has_active_subscription) {
      return next(to, from, cancel)
    }

    return cancel(route(ROUTES.CALENDAR))
  }
}
